<app-page-header-job [isCurveGray]="true" header="{{lang.jobheader}}" backgroundPath="assets/images/lead/bg.jpg">
</app-page-header-job>

<section class="section--feature">
    <div class="container">
        <div class="row radio--menu">
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <app-big-radio [active]="Personal"
                    icon="assets/images/icon/user-job.png" title="{{lang.jobtitleicon1}}"></app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio [active]="Education"
                    icon="assets/images/icon/mortarboard-job.png" title="{{lang.jobtitleicon2}}"></app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio [active]="Family"
                    icon="assets/images/icon/family-room-job.png" title="{{lang.jobtitleicon3}}"></app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio [active]="Experience"
                    icon="assets/images/icon/suitcase-job.png" title="{{lang.jobtitleicon4}}"></app-big-radio>
            </div>
        </div>
    </div>
</section>

<div ng-controller="MyController">
    <!-- ประวัติการศึกษา -->
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 text-center card p-5 mt-5 mb-5">
                <header class="heading-contact mb-5">
                    <h2 class="topic-title">{{lang.jobapplytiltle2}}</h2>
                </header>

                <form [formGroup]="formData">
                    <div formArrayName="excisePersonInfo1"
                        *ngFor="let creds of formData.get('excisePersonInfo1')['controls']; let i = index">
                        <div id="colore">
                            <ng-container [formGroupName]="i">
                                <div inline>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                            <div class="title-group">{{lang.jobnumber}} {{i+1}}</div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                            <app-button-delete-job text="{{lang.jobbtn2}}" (click)="removeEducation(i)">
                                                <button class="button--primary">
                                                    <span>
                                                        <a routerLink="">{{lang.jobbtn2}}</a>
                                                    </span>
                                                </button>
                                            </app-button-delete-job>
                                        </div>

                                        <div class="col-lg-3 col-md-3 col-sm-3 mb-4">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobedulevel}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="form-group">
                                                    <div class="dropdown">
                                                        <select formControlName="education" class="form-control"
                                                            [ngClass]="{ 'is-invalid' : Reqeducation }" (change)="setOther(i, $event.target.value)" style="padding-top: 8px; padding-bottom: 8px;">
                                                            <option *ngFor="let items of Laveleducation" [value]="items"
                                                                style=" border-radius: 50px;" >{{ items }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div *ngIf="Reqeducation" class="error-message">
                                                        {{lang.jobeduerror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-lg-3 col-md-3 col-sm-3 mb-4" *ngIf="flagOther[i]">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobapplydetailerror2}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="input">
                                                    <div class="input--container">
                                                        <input type="text" formControlName="educationOther"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': ReqeducationOther }">
                                                    </div>
                                                    <div *ngIf="ReqeducationOther" class="error-message">
                                                        {{lang.joberror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="col-lg-3 col-md-3 col-sm-3 mb-4">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobeduacademicyear}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="input">
                                                    <div class="input--container">
                                                        <input type="text" formControlName="graduate"
                                                            class="form-control" [maxLength]="4"
                                                            [ngClass]="{ 'is-invalid': Reqgraduate }" numbersOnly>
                                                    </div>
                                                    <div *ngIf="Reqgraduate" class="error-message">
                                                        {{lang.joberror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobeduuni}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="input">
                                                    <div class="input--container">
                                                        <input type="text" formControlName="NameOfInstitute"
                                                            class="form-control" [maxLength]="50"
                                                            [ngClass]="{ 'is-invalid': ReqNameOfInstitute }">
                                                    </div>
                                                    <div *ngIf="ReqNameOfInstitute" class="error-message">
                                                        {{lang.joberror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobedusection}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="input">
                                                    <div class="input--container">
                                                        <input type="text" formControlName="major" class="form-control"
                                                            [maxLength]="50" [ngClass]="{ 'is-invalid': Reqmajor }">
                                                    </div>
                                                    <div *ngIf="Reqmajor" class="error-message">
                                                        {{lang.joberror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-4 mb-4">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobedufrom}} {{lang.jobapplydetail11}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-5">
                                                        <div class="dropdown">
                                                            <select formControlName="FromMonth" class="form-control"
                                                                style="padding: 0;"
                                                                [ngClass]="{ 'is-invalid' : ReqFromMonth }">
                                                                <option *ngFor="let items of month; let i = index"
                                                                    [value]="i+1" style=" border-radius: 5px;">
                                                                    {{ items }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-1 col-md-1 col-sm-1 mb-1">
                                                        <p style="padding-top: 16px;">/</p>
                                                    </div>
                                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-5">
                                                        <input type="text" formControlName="FromYear"
                                                            class="form-control" [maxLength]="4"
                                                            [ngClass]="{ 'is-invalid': ReqFromYear }" numbersOnly
                                                            style=" border-radius: 5px;">
                                                    </div>
                                                </div>
                                                <div *ngIf="ReqFromMonth" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                                <div *ngIf="ReqFromYear" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 mb-4">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobeduto}} {{lang.jobapplydetail11}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-5">
                                                        <div class="dropdown">
                                                            <select formControlName="ToMonth" class="form-control"
                                                                style="padding: 0;"
                                                                [ngClass]="{ 'is-invalid' : ReqToMonth }">
                                                                <option *ngFor="let items of month; let i = index"
                                                                    [value]="i+1" style=" border-radius: 5px;">
                                                                    {{ items }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-1 col-md-1 col-sm-1 mb-1">
                                                        <p style="padding-top: 16px;">/</p>
                                                    </div>
                                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-5">
                                                        <input type="text" formControlName="ToYear" class="form-control"
                                                            [maxLength]="4" [ngClass]="{ 'is-invalid': ReqToYear }"
                                                            numbersOnly style=" border-radius: 5px;">
                                                    </div>
                                                </div>
                                                <!-- <my-date-picker-th formControlName="ToMonthYear"
                                                    (dateChanged)="onDateToChanged($event)" value="ToMonthYear"
                                                    id="ToMonthYear">
                                                </my-date-picker-th> -->

                                                <div *ngIf="ReqToMonth" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                                <div *ngIf="ReqToYear" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 mb-2">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobapplydetail12}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="input">
                                                    <div class="input--container">
                                                        <input type="text" formControlName="gpa" class="form-control"
                                                            [maxLength]="5" [ngClass]="{ 'is-invalid': Reqgpa }">
                                                    </div>
                                                    <div *ngIf="Reqgpa" class="error-message">
                                                        {{lang.joberror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </form>

                <div class="row" *ngIf="countEducation != 3">
                    <div class="col-lg-2 col-md-2 col-sm-2 mb-2 float-left">
                        <app-button-job text="{{lang.jobbtn1}}" (click)="addEducations()">
                            <button class="button--primary ml-auto mr-auto">
                                <span>
                                    <a>{{lang.jobbtn1}}</a>
                                </span>
                            </button>
                        </app-button-job>
                    </div>
                </div>

                <header class="heading-contact mb-5 mt-5">
                    <h2 class="topic-title">{{lang.jobapplydetail13}}</h2>
                </header>

                <form [formGroup]="formDataLanguage">
                    <div formArrayName="LanguageInfo"
                        *ngFor="let DataLan of  formDataLanguage.get('LanguageInfo')['controls']; let i = index">
                        <ng-container [formGroupName]="i">
                            <div inline>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                        <div class="title-group">{{lang.jobnumber}} {{i+1}}</div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                        <app-button-delete-job text="{{lang.jobbtn2}}" (click)="removeLanguage(i)">
                                            <button class="btn btn-danger mr-auto">
                                                <span>
                                                    <a routerLink="">{{lang.jobbtn2}}</a>
                                                </span>
                                            </button>
                                        </app-button-delete-job>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
                                        <div class="col-lg-3 col-md-3 col-sm-12 p-0">
                                            <div class="form--item">
                                                <div class="title d-flex">{{lang.jobapplydetail14}}<p class="req pl-3">*</p>
                                                </div>
                                                <div class="input">
                                                    <div class="input--container">
                                                        <input type="text" formControlName="language"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': Reqlanguage }" [maxLength]="50">
                                                    </div>
                                                    <div *ngIf="Reqlanguage" class="error-message">
                                                        {{lang.joberror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- ไฟล์ -->
                                    <!-- <div class="col-lg-4 col-md-4 col-sm-12 mb-4">
                                        <div class="title d-flex">{{lang.jobedutest}}</div>
                                        <input type="file" class="pl-5" (change)="getFile($event,i)"
                                            formControlName="file1" #fileUpload hidden>

                                        <div class="form--item">
                                            <div class="input">
                                                <div *ngFor="let listfile of Filenames; let s = index"
                                                    class="input--container">
                                                    <div *ngIf="s == i">
                                                        <input lass="pl-5" type="text" formControlName="file1" accept=""
                                                            placeholder='' [ngClass]="{ 'is-invalid': Reqfile1 }"
                                                            disabled />
                                                    </div>

                                                </div>
                                                <div *ngIf="Reqfile1" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- ลบ -->
                                    <!-- <div class="col-lg-2 col-md-2 col-sm-3 mb-4">
                                        <div *ngIf="Filenames[i] != '' && Filenames[i] != undefined">
                                          <div class="title file mt-1">{{lang.jobeduwarning3}}</div>
                                          <app-button-job text="{{lang.jobbtn2}}" (click)="Delete(i)">
                                            <button class="button--blue ml-auto mr-auto">
                                              <span>
                                                <a>{{lang.jobbtn2}}</a>
                                              </span>
                                            </button>
                                          </app-button-job>
                                        </div>
                                      </div> -->
                                      <!-- แนบไฟล์ -->
                                    <!-- <div class="col-lg-2 col-md-2 col-sm-3 mb-4">
                                        <div class="title file mt-1">.pdf .jpg .png .docx </div>
                                        <app-button-job text="{{lang.jobbtn3}}" (click)="fileUpload.click()">
                                            <button class="button--blue ml-auto mr-auto">
                                                <span>
                                                    <a>{{lang.jobbtn3}}</a>
                                                </span>
                                            </button>
                                        </app-button-job>
                                    </div> -->
                                    <!-- อัพโหลด -->
                                    <!-- <div class="col-lg-4 col-md-4 col-sm-3 mb-4">
                                        <div class="title file mt-1">{{lang.jobeduwarning1}}</div>
                                        <app-button-job text="{{lang.jobbtn4}}" (click)="UploadFile(i)">
                                            <button class="button--blue ml-auto mr-auto">
                                                <span>
                                                    <a>{{lang.jobbtn4}}</a>
                                                </span>
                                            </button>
                                        </app-button-job>
                                    </div> -->
                                </div>

                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedutestresult1}}<p class="req pl-3">*</p>
                                            </div>
                                            <div class="form-group">
                                                <div class="dropdown">
                                                    <select formControlName="speaking" class="form-control"
                                                        [ngClass]="{ 'is-invalid' : Reqspeaking }">
                                                        <option *ngFor="let items of skill" [value]="items"
                                                            style=" border-radius: 50px;">{{ items }}</option>
                                                    </select>
                                                </div>
                                                <div *ngIf="Reqspeaking" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedutestresult2}}<p class="req pl-3">*</p>
                                            </div>
                                            <div class="form-group">
                                                <div class="dropdown">
                                                    <select formControlName="understanding" class="form-control"
                                                        [ngClass]="{ 'is-invalid' : Requnderstanding }">
                                                        <option *ngFor="let items of skill" [value]="items"
                                                            style=" border-radius: 50px;">{{ items }}</option>
                                                    </select>
                                                </div>
                                                <div *ngIf="Requnderstanding" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedutestresult3}}<p class="req pl-3">*</p>
                                            </div>
                                            <div class="form-group">
                                                <div class="dropdown">
                                                    <select formControlName="reading" class="form-control"
                                                        [ngClass]="{ 'is-invalid' : Reqreading }">
                                                        <option *ngFor="let items of skill" [value]="items">{{ items }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div *ngIf="Reqreading" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedutestresult4}}<p class="req pl-3">*</p>
                                            </div>
                                            <div class="form-group">
                                                <div class="dropdown">
                                                    <select formControlName="writting" class="form-control"
                                                        [ngClass]="{ 'is-invalid' : Reqwritting }">
                                                        <option *ngFor="let items of skill" [value]="items">{{ items }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div *ngIf="Reqwritting" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </form>

                <div class="row" *ngIf="countLanguage != 3">
                    <div class="col-lg-2 col-md-2 col-sm-2 mb-2 float-left">
                        <app-button-job text="{{lang.jobbtn1}}" (click)="addLanguage()">
                            <button class="button--primary ml-auto mr-auto" ng-click="AddInfo()">
                                <span>
                                    <a>{{lang.jobbtn1}}</a>
                                </span>
                            </button>
                        </app-button-job>
                    </div>
                </div>
<!-- อบรม/สัมนา -->
                <header class="heading-contact mb-5 mt-5">
                    <h2 class="topic-title">{{lang.jobapplydetail33}}</h2>
                    <p class="ingnor-top">* {{lang.jobeduwarning2}} -</p>
                </header>

                <form [formGroup]="formDataTraining">
                    <div formArrayName="TrainingInfo"
                        *ngFor="let DataLic of formDataTraining.get('TrainingInfo')['controls']; let i = index">
                        <ng-container [formGroupName]="i">
                            <div inline>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                        <div class="title-group">{{lang.jobapplydetail34}} {{i+1}}</div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                        <app-button-delete-job text="{{lang.jobbtn2}}" (click)="removeTraining(i)">
                                            <button class="btn btn-danger mr-auto">
                                                <span>
                                                    <a routerLink="">{{lang.jobbtn2}}</a>
                                                </span>
                                            </button>
                                        </app-button-delete-job>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobapplydetail34}}
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input type="text" formControlName="training_subject"
                                                        class="form-control" [maxLength]="50"
                                                        [ngClass]="{ 'is-invalid': Reqtraining_subject }">
                                                </div>
                                                <div *ngIf="Reqtraining_subject" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobapplydetail35}}
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input type="text" formControlName="training_institute" class="form-control"
                                                        [ngClass]="{ 'is-invalid': Reqtraining_institute }">
                                                </div>
                                                <div *ngIf="Reqtraining_institute" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobapplydetail36}}
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input type="text" formControlName="training_period" class="form-control"
                                                        [ngClass]="{ 'is-invalid': Reqtraining_period }">
                                                </div>
                                                <div *ngIf="Reqtraining_period" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedulicensedate}}
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <my-date-picker-th *ngIf="flag == 'th'; else elseDate" formControlName="licenseDate" value="licenseDate"
                                                        id="licenseDate" [options]="myDatePickerOptions" (dateChanged)="onDateChanged($event)">
                                                    </my-date-picker-th>
                                                    <ng-template #elseDate>
                                                        <my-date-picker formControlName="licenseDate" value="licenseDate"
                                                        id="licenseDate" [options]="myDatePickerOptionsEN" (dateChanged)="onDateChanged($event)">
                                                        </my-date-picker>
                                                    </ng-template>
                                                </div>
                                                <div *ngIf="ReqlicenseDate" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </form>

                <div class="row" *ngIf="countTraining != 3">
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <app-button-job text="{{lang.jobbtn1}}" (click)="addTraining()">
                            <button class="button--primary ml-auto mr-auto">
                                <span>
                                    <a routerLink="">{{lang.jobbtn1}}</a>
                                </span>
                            </button>
                        </app-button-job>
                    </div>
                </div>
<!-- อบรม/สัมนา -->
                <header class="heading-contact mb-5 mt-5">
                    <h2 class="topic-title">{{lang.jobapplydetail15}}</h2>
                    <p class="ingnor-top">* {{lang.jobeduwarning2}} -</p>
                </header>

                <form [formGroup]="formDataLicense">
                    <div formArrayName="LicenseInfo"
                        *ngFor="let DataLic of formDataLicense.get('LicenseInfo')['controls']; let i = index">
                        <ng-container [formGroupName]="i">
                            <div inline>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                        <div class="title-group">{{lang.jobnumber}} {{i+1}}</div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                        <app-button-delete-job text="{{lang.jobbtn2}}" (click)="removeLicense(i)">
                                            <button class="btn btn-danger mr-auto">
                                                <span>
                                                    <a routerLink="">{{lang.jobbtn2}}</a>
                                                </span>
                                            </button>
                                        </app-button-delete-job>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedulicense}}
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input type="text" formControlName="licenseName"
                                                        class="form-control" [maxLength]="50"
                                                        [ngClass]="{ 'is-invalid': ReqlicenseName }">
                                                </div>
                                                <div *ngIf="ReqlicenseName" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedulicenseno}}
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input type="text" formControlName="licenseNo" class="form-control"
                                                        [ngClass]="{ 'is-invalid': ReqlicenseNo }">
                                                </div>
                                                <div *ngIf="ReqlicenseNo" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 mb-3">
                                        <div class="form--item">
                                            <div class="title d-flex">{{lang.jobedulicensedate}}
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <my-date-picker-th *ngIf="flag == 'th'; else elseDate" formControlName="licenseDate" value="licenseDate"
                                                        id="licenseDate" [options]="myDatePickerOptions" (dateChanged)="onDateChanged($event)">
                                                    </my-date-picker-th>
                                                    <ng-template #elseDate>
                                                        <my-date-picker formControlName="licenseDate" value="licenseDate"
                                                        id="licenseDate" [options]="myDatePickerOptionsEN" (dateChanged)="onDateChanged($event)">
                                                        </my-date-picker>
                                                    </ng-template>
                                                </div>
                                                <div *ngIf="ReqlicenseDate" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </form>

                <div class="row" *ngIf="countLicense != 2">
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <app-button-job text="{{lang.jobbtn1}}" (click)="addLicense()">
                            <button class="button--primary ml-auto mr-auto">
                                <span>
                                    <a routerLink="">{{lang.jobbtn1}}</a>
                                </span>
                            </button>
                        </app-button-job>
                    </div>
                </div>

                <header class="heading-contact mb-5 mt-5">
                    <h2 class="topic-title">{{lang.jobedutalent}} </h2>
                    <p class="ingnor">* {{lang.jobeduwarning2}} -</p>
                </header>

                <form [formGroup]="formDataComputerProgram">
                    <div formArrayName="ComputerProgramInfo"
                        *ngFor="let DataComputerProgram of  formDataComputerProgram.get('ComputerProgramInfo')['controls']; let i = index">
                        <ng-container [formGroupName]="i">
                            <div inline>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="form--item">
                                            <div class="title-group mb-4" *ngIf="i >= 1">{{lang.jobnumber}} {{i+1}}</div>
                                            <div class="title d-flex">{{lang.jobeducomputerprogram}}
                                                <!-- <p class="max-character" [ngStyle]="{'color': ComputerProgram.value.length == 145 ? 'red' : 'black'}">
                                                    ({{ComputerProgram.value.length}}/ 145 ตัวอักษร)</p> -->
                                            </div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input type="text" formControlName="ComputerProgram"
                                                        class="form-control"
                                                        [ngClass]="{ 'is-invalid': ReqComputerProgram }">
                                                </div>
                                                <div *ngIf="ReqComputerProgram" class="error-message">
                                                    {{lang.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-5 add-pdt-com" *ngIf="i >=1">
                                        <app-button-job text="{{lang.jobbtn2}}" (click)="removeComputer(i)">
                                            <button class="btn btn-danger mr-auto">
                                                <span>
                                                    <a routerLink="">{{lang.jobbtn2}}</a>
                                                </span>
                                            </button>
                                        </app-button-job>
                                    </div>

                                </div>
                            </div>
                        </ng-container>
                    </div>
                </form>

                <!-- <div class="row" *ngIf="clickCount != 5">
                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 add-pdt">
                        <app-button-job text="{{lang.jobbtn1}}" (click)="addComputer()">
                            <button class="button--primary ml-auto mr-auto">
                                <span>
                                    <a routerLink="">{{lang.jobbtn1}}</a>
                                </span>
                            </button>
                        </app-button-job>
                    </div>
                </div> -->

                <!-- <header class="heading-contact mb-5 mt-5">
                    <h2 class="topic-title">{{lang.jobedutalent}}</h2>
                    <p class="ingnor">* {{lang.jobeduwarning2}} -</p>
                </header> -->

                <form [formGroup]="formDataOther">
                    <div formArrayName="OtherInfo"
                        *ngFor="let DataOther of  formDataOther.get('OtherInfo')['controls']; let i = index">
                        <ng-container [formGroupName]="i">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 mb-5">
                                    <div class="form--item">
                                        <div class="title-group mb-4" *ngIf="i >= 1">{{lang.jobnumber}} {{i+1}}</div>
                                        <div class="title d-flex">{{lang.jobedutalent}}
                                            <!-- <p class="max-character" [ngStyle]="{'color': other.value.length == 145 ? 'red' : 'black'}">
                                                ({{other.value.length}}/ 145 ตัวอักษร)</p> -->
                                        </div>
                                        <div class="input">
                                            <div class="input--container">
                                                <input type="text" formControlName="other" class="form-control"
                                                    [ngClass]="{ 'is-invalid': Reqother }">
                                            </div>
                                            <div *ngIf="Reqother" class="error-message">
                                                {{lang.joberror1}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 mb-5 add-pdt-com" *ngIf="i >=1">
                                    <app-button-job text="{{lang.jobbtn2}}" (click)="removeOther(i)">
                                        <button class="btn btn-danger mr-auto">
                                            <span>
                                                <a routerLink="">{{lang.jobbtn2}}</a>
                                            </span>
                                        </button>
                                    </app-button-job>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </form>

                <!-- <div class="row" *ngIf="clickCount != 5">
                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 add-pdt">
                        <app-button-job text="{{lang.jobbtn1}}" (click)="addOther()">
                            <button class="button--primary ml-auto mr-auto">
                                <span>
                                    <a routerLink="">{{lang.jobbtn1}}</a>
                                </span>
                            </button>
                        </app-button-job>
                    </div>
                </div> -->

                <!-- ถัดไป -->
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                        <app-button text="{{lang.jobbtn6}}" (click)="goback()">
                            <button class="button--primary ml-auto mr-auto">
                                <span>
                                    <a>{{lang.jobbtn6}}</a>
                                </span>
                            </button>
                        </app-button>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                        <app-button text="{{lang.jobbtn5}}" (click)="goFamily()">
                            <button class="button--primary ml-auto mr-auto">
                                <span>
                                    <a>{{lang.jobbtn5}}</a>
                                </span>
                            </button>
                        </app-button>
                    </div>
                </div>
                <!-- ถัดไป -->
            </div>
        </div>
    </div>
</div>
<!-- ประวัติการศึกษา -->